import React from "react";

// Do not import CSS, otherwise it will be rendered when the file is loaded, not rendered
// and will create a visual glitch.

function ProdError() {
  // Hack to override the property only when this component is rendered.
  document.getElementById("root").style = "display: block";
  return (
    <div id="error-block">
      <link rel="stylesheet" href="/error_pages/error.css" />
      <img src="/error_pages/robot.svg" alt="Broken robot" />
      <p>
        An error occurred during the payment request, an alert has been sent to
        our team to investigate the issue.
      </p>
    </div>
  );
}
export default ProdError;
